var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKundenabsicherungsprofil = function SvgKundenabsicherungsprofil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#637384",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    clipPath: "url(#Kundenabsicherungsprofil_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.61 10.1a4.3 4.3 0 1 0 0-8.6 4.3 4.3 0 0 0 0 8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.5 19.64.7-3.47a7.56 7.56 0 0 1 7.41-6.08 7.43 7.43 0 0 1 4.59 1.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.77 22.5a5.73 5.73 0 1 0 0-11.46 5.73 5.73 0 0 0 0 11.46ZM13.91 16.77h5.73M16.77 13.91v5.73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Kundenabsicherungsprofil_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgKundenabsicherungsprofil;